import React from "react";
import {
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
} from "@mui/material";

function SpecialNotes() {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Special Notes and instructions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              Quote includes: Business to Business transportation, fuel,
              permits, escorts. <br></br>Insurance for units being transported.
              Open communication and updates 24/7. <br></br>
              Coordination and logistics prior to pickup, while transport and
              after delivery as well. Premium service during entire transaction.{" "}
              <br></br>Above information is an estimate of services/goods
              described above. Payment will be collected in prior to provision
              of services/goods described in this quote.
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SpecialNotes;
